var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, OnInit } from '@angular/core';
import { SCREEN_SIZE, SearchType, ListingCategory } from '../../../classes/enums';
import { FiltersSearch } from './filters-search';
import { take } from 'rxjs/operators';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
var FiltersSearchComponent = /** @class */ (function (_super) {
    __extends(FiltersSearchComponent, _super);
    function FiltersSearchComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.SCREEN_SIZE = SCREEN_SIZE;
        return _this;
    }
    FiltersSearchComponent.prototype.closeDropdowns = function (dropdownName, newStatus) {
        this.showMore = false;
        if (dropdownName)
            this[dropdownName] = newStatus;
    };
    FiltersSearchComponent.prototype.onPageClick = function ($event) {
        if (!this.formElementRef.nativeElement.contains($event.target) || (this.moreDropdownRef && !this.moreDropdownRef.nativeElement.contains($event.target))) {
            this.closeDropdowns();
        }
    };
    FiltersSearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.addSub(this.communicationService.screenSize.subscribe(function (screenSize) {
            if (_this.screenSize > SCREEN_SIZE.MOBILE_ONLY) {
                _this.listenToFormChanges();
                _this.fetchFilters();
            }
            else if (_this.screenSize === SCREEN_SIZE.MOBILE_ONLY) {
                _this.subscribeToFiltersChanges();
            }
        }));
        this.addSub(this.preferencesService.agentSearchFiltersChanged
            .pipe(distinctUntilChanged(function (a, b) { return a.text !== b.text; }))
            .subscribe(function (filters) {
            _this.onFilterChange(filters);
        }));
    };
    FiltersSearchComponent.prototype.fetchFilters = function () {
        var _this = this;
        if (this.isSubscribedToFilterChanges)
            return;
        else
            this.isSubscribedToFilterChanges = true;
        (this.searchType === SearchType.AGENT ?
            this.preferencesService.agentSearchFiltersChanged :
            this.preferencesService.officeSearchFiltersChanged).pipe(take(1)).toPromise()
            .then(function (filters) { return _this.onFilterChange(filters); });
    };
    FiltersSearchComponent.prototype.subscribeToFiltersChanges = function () {
        var _this = this;
        this.addSub((this.searchType === SearchType.AGENT ?
            this.preferencesService.agentSearchFiltersChanged :
            this.preferencesService.officeSearchFiltersChanged).pipe(distinctUntilChanged(), debounceTime(100)).subscribe(function (filters) {
            _this.onFilterChange(filters);
        }));
    };
    FiltersSearchComponent.prototype.onFilterChange = function (filters) {
        if (this.currentShownListingType === ListingCategory.COMMERCIAL) {
            this._updateRealEstateFilterForPropertyType(filters, 'Commercial');
        }
        this.updateFilters(filters);
    };
    return FiltersSearchComponent;
}(FiltersSearch));
export { FiltersSearchComponent };
